import styled from '@emotion/styled'

import { Space, Typography } from '../..'
import { StyledFeesBox } from './primitives'

export type Fee = {
  calculatedOn: string
  counterpartyId?: string
  frequency: string
  isVatApplicable: boolean
  name: string
  rate: string
}

export type FeesProps = {
  displayCptyId?: boolean
  fees: Fee[]
  title: string
}

const StyledTable = styled.table`
  width: 100%;
  font-weight: normal;
  font-size: 11px;
  border-collapse: collapse;

  th {
    font-weight: normal;
    padding: 16px 8px;
    background-color: var(--White96);
    color: var(--Graphite);
    text-align: left;
    border-top: 1px solid var(--White96);
    border-bottom: 1px solid var(--White96);
  }

  .name {
    width: 28%;
  }

  .calculated-on {
    width: 25%;
  }

  .frequency {
    width: 17%;
  }

  .vat {
    width: 10%;
  }

  .amount {
    width: 21%;
  }

  th.name {
    font-weight: 600;
  }

  td {
    padding: 16px 8px;
    border-top: 1px dashed var(--White96);
    border-bottom: 1px dashed var(--White96);
  }
`

export function Fees({ displayCptyId, fees, title }: FeesProps) {
  const calcOns = fees.map(fee => fee.calculatedOn)
  const containsTotalTradeValue = calcOns.includes('Total trade value')

  if (fees) {
    return (
      <StyledFeesBox>
        <StyledTable>
          <thead>
            <tr>
              <th className="name">{title}</th>
              <th className="calculated-on">Calculated on</th>
              <th className="frequency">Frequency</th>
              <th className="vat">VAT</th>
              {displayCptyId && <th className="vat">Counterparty</th>}
              <th className="amount">Rate (%)</th>
            </tr>
          </thead>
          <tbody>
            {fees.map((fee, i) => (
              <tr key={fee.name} data-testid={`fee-row-${i}`}>
                <td className="name" data-testid="fee-name">
                  {fee.name}
                </td>
                <td className="calculated-on" data-testid="fee-calculated-on">
                  {fee.calculatedOn}
                </td>
                <td className="frequency" data-testid="fee-frequency">
                  {fee.frequency}
                </td>
                <td className="vat" data-testid="fee-vat">
                  {fee.isVatApplicable ? 'Yes' : 'No'}
                </td>
                {displayCptyId && (
                  <td className="vat" data-testid="fee-counterparty">
                    {fee.counterpartyId}
                  </td>
                )}
                <td className="amount" data-testid="fee-amount">
                  {fee.rate}
                </td>
              </tr>
            ))}
          </tbody>
        </StyledTable>
        {containsTotalTradeValue && (
          <Space mt={3}>
            <Typography fontSize="13px" variant="b3">
              * Total trade value means Ref Portfolio Value Excl Leverage, Inc Clearing Provision
            </Typography>
          </Space>
        )}
      </StyledFeesBox>
    )
  }
}
